export function shallowCompare(current, next, checkProperties) {
    const { length } = checkProperties;
    for (let index = 0; index < length; index++) {
        if (current[checkProperties[index]] !== next[checkProperties[index]]) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=should-component-update.js.map